import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "p-head-title" }
const _hoisted_2 = { class: "font-size-12-400 text-center" }
const _hoisted_3 = { class: "font-size-12-400 pa-1" }
const _hoisted_4 = { class: "p-text-sm" }

import {computed, onMounted, reactive} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {packagesService} from '@/api/services/package';
import {useSettingsStore} from '@/api/store/settings';
import {useCartStore} from '@/api/store/cart';
import ButtonBase from "@/components/custom/ButtonBase.vue";
import Icon from "@/components/Icons/Icon.vue";

const SUPPLIER_INDEX = null;


export default /*@__PURE__*/_defineComponent({
  __name: 'PackageView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const settingsStore = useSettingsStore();
const cartStore = useCartStore();

const state = reactive({
  package: null as any | null,
  service: null as any | null
});

const loadPackage = async () => {
  
  const packageId = Number(route.params.id);

  await packagesService.show(packageId).then((response) => {
    state.package = response.package;
    // get the first service from the package in order to book it
    state.service = response.package?.services[0];
    router.currentRoute.value.meta.title = state.package.name;
  }).catch((err) => {
    console.log(err)
  })

  
};

const addPackage = () => {
  
  cartStore.addItem(SUPPLIER_INDEX, state.package.id, 1, "App\\Models\\v3\\ClinicPackage").then((res) => {
    router.push({name: 'shopping-cart'});
  }).catch((error) => {
    settingsStore.error = true;
    settingsStore.error_message = "This item may be out of stock or no longer available from the supplier."
  });
};

const getImage = computed(() => {
  if (!state.package.image && !state.package.image?.file) return null;

  return state.package.image?.file?.file_path;
})

const getTotalServices = computed(() => {
  const totalServices = state.package?.services.length ?? 0;
  return totalServices > 1 ? `${totalServices} Services` : `${totalServices} Service`;
})

onMounted(loadPackage)

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.package)
    ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
        default: _withCtx(() => [
          (getImage.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "logo-container m-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                    class: "logo-container__image"
                  }, null, 4)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_sheet, {
                key: 1,
                class: "icon-container secondary-background-button-color"
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, { icon: "package-icon" })
                ]),
                _: 1
              })),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "pa-3 ma-1 text-center sw-nav",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(state.package.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, [
                    _createTextVNode(_toDisplayString(getTotalServices.value) + " ", 1),
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "secondary-button-color" }, "|", -1)),
                    _createTextVNode(" " + _toDisplayString(state.package?.price_display), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (state.package?.services)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-center" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.package?.services, (service, index) => {
                        return (_openBlock(), _createBlock(_component_v_sheet, {
                          key: `package-services-${index}`,
                          color: "white"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_3, "(" + _toDisplayString(index + 1) + ") " + _toDisplayString(service.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "d-flex align-center justify-center ga-2 mt-2",
                    color: "white"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Icon, { icon: "location-icon" }),
                      _createVNode(Icon, { icon: "phone-icon" }),
                      _createVNode(Icon, { icon: "video-icon" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "px-3 ma-1 text-center overflow-y-auto",
                    color: "white",
                    height: "100"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(state.package?.description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "mt-1",
            width: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "text-center",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        class: "px-3 ma-1 text-center sw-nav",
                        color: "white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ButtonBase, {
                            "custom-class": ['primary-button text-white mb-3'],
                            text: "Book Now",
                            width: "100%",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'book-service',
                 params: {
                  id: state.service.clinic_service_id ,
                },
                 query: {
                  packageServiceId: state.service.id 
                }
                })))
                          }),
                          _createVNode(ButtonBase, {
                            "custom-class": ['white-btn font-size-12-600'],
                            text: "Add to Cart",
                            width: "100%",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (addPackage()))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})